export const CONTACTS = {
  organizationName: process.env.REACT_APP_ORGANIZATION_NAME || '',
  address: {
    full: process.env.REACT_APP_CONTACT_ADDRESS || '',
    mapUrl: process.env.REACT_APP_CONTACT_MAP_URL || '',
  },
  phone: {
    display: process.env.REACT_APP_CONTACT_PHONE_DISPLAY || '',
    tel: process.env.REACT_APP_CONTACT_PHONE_TEL || '',
  },
  facebook: process.env.REACT_APP_CONTACT_FACEBOOK || '',
};
